import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { saultSteMarieConfig } from "./data";

export default function SaultSteMariePage() {
  return <CityPageTemplate config={saultSteMarieConfig} />;
}